import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import { useMemo } from 'react';
import { formatFileSize } from '../../util/file-size-format.util';
import { Colors } from '../../util/theme';
var fileTypeIcons = {
    pdf: _jsx(PictureAsPdfOutlinedIcon, { color: "error" }),
    png: _jsx(ImageOutlinedIcon, { color: "action" }),
    jpg: _jsx(ImageOutlinedIcon, { color: "action" }),
    jpeg: _jsx(ImageOutlinedIcon, { color: "action" }),
    gif: _jsx(ImageOutlinedIcon, { color: "action" }),
    txt: _jsx(DescriptionOutlinedIcon, { color: "action" }),
    doc: _jsx(InsertDriveFileOutlinedIcon, { color: "primary" }),
    docx: _jsx(InsertDriveFileOutlinedIcon, { color: "primary" }),
    xls: _jsx(InsertDriveFileOutlinedIcon, { color: "success" }),
    xlsx: _jsx(InsertDriveFileOutlinedIcon, { color: "success" }),
    default: _jsx(InsertDriveFileOutlinedIcon, { color: "disabled" }),
};
export var Attachment = function (_a) {
    var onRemove = _a.onRemove, file = _a.file, disabled = _a.disabled;
    var handleDeleteFile = function () {
        if (onRemove) {
            onRemove();
        }
    };
    var fileName = useMemo(function () {
        if (file === null || file === void 0 ? void 0 : file.nomeOriginal) {
            return file.nomeOriginal;
        }
        return '';
    }, [file]);
    var fileType = useMemo(function () { return (file === null || file === void 0 ? void 0 : file.arquivoTipo) || ''; }, [file]);
    var fileSize = useMemo(function () { return ((file === null || file === void 0 ? void 0 : file.tamanhoArquivo) ? formatFileSize(file.tamanhoArquivo) : ''); }, [file]);
    var fileIcon = useMemo(function () {
        var _a;
        var extension = (_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        return (extension && fileTypeIcons[extension]) || fileTypeIcons.default;
    }, [fileName]);
    if (!file) {
        return null;
    }
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexDirection: 'row',
            width: '100%',
            minHeight: '4rem',
            backgroundColor: '#F5F5F5',
            borderRadius: '0.25rem',
            border: '1px solid #E4E4E4',
            marginTop: '5px',
        }, children: [_jsx(Avatar, { sx: {
                    backgroundColor: 'transparent',
                    ml: '0.5rem',
                }, children: fileIcon }), _jsxs(Box, { sx: {
                    flexGrow: 1,
                    overflow: 'hidden',
                }, children: [_jsx(Typography, { title: file === null || file === void 0 ? void 0 : file.nomeOriginal, sx: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        }, children: fileName }), _jsxs(Typography, { color: "text.secondary", fontSize: "0.875rem", children: [fileType, ", ", fileSize] })] }), !disabled && onRemove && (_jsx(Box, { children: _jsx(IconButton, { "aria-label": "delete", onClick: handleDeleteFile, children: _jsx(CloseIcon, {}) }) })), _jsx(Box, { sx: {
                    backgroundColor: Colors.VERDE_GOV,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'stretch',
                    borderTopRightRadius: '0.25rem',
                    borderBottomRightRadius: '0.25rem',
                    borderTop: '1px solid #007932',
                    borderRight: '1px solid #007932',
                    borderBottom: '1px solid #007932',
                }, children: _jsx(CheckCircleOutlineOutlinedIcon, { sx: { color: 'white', m: 1 } }) })] }));
};
